import { Box, Button, Container, TextField, Typography } from "@mui/material";
import { Stack } from "@mui/system";
import React, { ChangeEvent, FormEvent, useState } from "react";
import { CreateFormProps } from "../../commonTypes/FormProps";
import { useAppDispatch } from "../../hooks";
import { templatesActions } from "../../reduxSlices/template";

const TEMPLATE_STARTER_CODE = `from efficalc import Heading, Input, Calculation, TextBlock, ft_to_in, maximum, sqrt
from efficalc.sections import ALL_AISC_WIDE_FLANGE_NAMES, get_aisc_wide_flange


def calculation():
    # Begin your calculation template here. For example, C=A*B would be:
    Heading("My First Calculation", numbered=False)

    A = Input("A", 2, "in", "A description for variable A")
    B = Input("B", 3, "in", "Another variable")

    Calculation("C", A*B, "in^2", reference="Code 5.12.6", result_check=True)

    TextBlock("This is an example to get you started. Try changing some equations and variables!")
    
    `;

const defaultValues = {
  name: "",
  description: "",
  fileContent: TEMPLATE_STARTER_CODE,
};

export default function CreateTemplateForm({ onSubmit }: CreateFormProps) {
  const dispatch = useAppDispatch();
  const [formValues, setValues] = useState(defaultValues);

  const handleChange = (event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = event.target;
    setValues({ ...formValues, [name]: value });
  };

  const handleSubmit = (event: FormEvent<HTMLDivElement>) => {
    event.preventDefault();
    dispatch(templatesActions.createAndGetTemplate(formValues));
    setValues(defaultValues);
    if (onSubmit) onSubmit();
  };

  return (
    <Container maxWidth="sm">
      <Box component="form" onSubmit={handleSubmit}>
        <Stack spacing={2}>
          <Typography variant="h3">New Calculation Template:</Typography>
          <TextField
            required
            id="template-name"
            name="name"
            label="Template Name"
            value={formValues.name}
            onChange={handleChange}
          />
          <TextField
            multiline
            id="template-description"
            name="description"
            label="Template Description"
            value={formValues.description}
            onChange={handleChange}
            inputProps={{ maxLength: 500 }}
          />
          {/* <TextField
            hidden
            multiline
            id="template-file-content"
            name="fileContent"
            label="Template Content (paste text from file)"
            value={formValues.fileContent}
            onChange={handleChange}
            inputProps={{ maxLength: 50000 }}
          /> */}
          <Button fullWidth type="submit" variant="contained">
            Submit
          </Button>
        </Stack>
      </Box>
    </Container>
  );
}
